export const CREATE_PROJECT_DELIVERABLE_MUTATION = `
    mutation CreateDeliverable($project_id: Int!, $project_creator_id: Int, $name: [String], $due_date: String, $draft_due_date: String, $target_live_date: String, $notes: String, $custom_properties: [CustomPropertyInput]) {
        createDeliverable(project_id: $project_id, project_creator_id: $project_creator_id, name: $name, due_date: $due_date, draft_due_date: $draft_due_date, target_live_date: $target_live_date,notes: $notes, custom_properties: $custom_properties) {
            id
            name
            type
            due_date
            draft_due_date
            target_live_date
            notes
            assets {
                id
            }
            creator {
                id
                deliverable_count
            }
            products {
                id
                name
                image_url
                archived
                product_retailers {
                    id
                    sku
                    url
                    image_url
                }
            }
            destinations {
                id
                url
                status
                account_social_channel {
                    id
                    handle
                    type
                    url
                    avatar
                }
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const UPDATE_PROJECT_DELIVERABLE_MUTATION = `
    mutation UpdateDeliverable($project_id: Int!, $project_deliverable_id: Int!, $name: String, $due_date: String, $draft_due_date: String, $target_live_date: String, $notes: String, $custom_properties: [CustomPropertyInput]) {
        updateDeliverable(project_id: $project_id, project_deliverable_id: $project_deliverable_id, name: $name, due_date: $due_date, draft_due_date: $draft_due_date, target_live_date: $target_live_date, notes: $notes, custom_properties: $custom_properties) {
            id
            name
            type
            status
            due_date
            draft_due_date
            target_live_date
            notes
            creator {
                id
                deliverable_count
                notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
            },
            assets {
            id
            title
            status
                versions {
                    id
                    title
                    description
                    version
                    status
                }
            }
            products {
                id
                name
                image_url
                archived
            }
            destinations {
                id
                url
                status
                account_social_channel {
                    id
                    handle
                    type
                    url
                    avatar
                }
            }
           custom_properties {
                key
                value
            }
        }
    }
`;

export const UPDATE_PROJECT_DELIVERABLE_STATUS_MUTATION = `
    mutation UpdateDeliverableStatus($project_id: Int!, $project_deliverable_id: Int!, $status: ProjectDeliverableStatusEnum!) {
        updateDeliverableStatus(project_id: $project_id, project_deliverable_id: $project_deliverable_id, status: $status) {
            id
            name
            type
            status
            due_date
            draft_due_date
            target_live_date
            notes
            creator {
                id
                deliverable_count
                notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
            }
        }
    }
`;

export const UPDATE_DELIVERABLE_ASSET_METADATA_MUTATION = `
    mutation UpdateDeliverableAssetMetadata($project_id: Int!, $project_deliverable_asset_id: Int!, $metadata: [ProjectDeliverableAssetDestinationInput]) {
        updateDeliverableAssetMetadata(project_id: $project_id, project_deliverable_asset_id: $project_deliverable_asset_id, metadata: $metadata) {
            id
            title
            description
            destination {
                id
                url
                status
            }
        }
    }
`;

export const UPDATE_PROJECT_DELIVERABLE_ASSET_STATUS_MUTATION = `
    mutation UpdateDeliverableAssetStatus($project_id: Int!, $project_deliverable_id: Int!, $asset_version_id: Int!, $status: ProjectDeliverableAssetVersionStatusEnum!) {
        updateDeliverableAssetStatus(project_id: $project_id, project_deliverable_id: $project_deliverable_id, asset_version_id: $asset_version_id, status: $status) {
            id
            title
            status
        }
    }
`;

export const REMOVE_PROJECT_DELIVERABLE_MUTATION = `
    mutation DeleteDeliverable($project_id: Int!, $project_deliverable_ids: [Int]) {
        deleteDeliverable(project_id: $project_id, project_deliverable_ids: $project_deliverable_ids)
    }
`;

export const SYNC_PROJECT_DELIVERABLE_PRODUCTS_MUTATION = `
    mutation SyncProducts($project_id: Int!, $project_deliverable_id: Int!, $product_ids: [Int]!) {
        syncProducts(project_id: $project_id, project_deliverable_id:  $project_deliverable_id, product_ids: $product_ids) {
            id
            name
            image_url
            archived
            product_retailers {
                id
                sku
                url
                image_url
            }
        }
    }
`;

export const ATTACH_PROJECT_DELIVERABLE_MEDIA_MUTATION = `
    mutation AttachMedia($project_id: Int!, $project_deliverable_id: Int!, $deliverable_asset_id: Int!, media_id: Int) {
        attachMedia(project_id: $project_id, project_deliverable_id: $project_deliverable_id, deliverable_asset_id: $deliverable_asset_id, media_id: $media_id) {
            id
            versions {
                id
                media {
                    id
                    name
                    type
                    status
                    description
                    custom_properties {
                        key
                        value
                    }
                }
            }
        }
    }
`;

export const DETACH_PROJECT_DELIVERABLE_MEDIA_MUTATION = `
    mutation DetachMedia($project_id: Int!, $project_deliverable_id: Int!, $deliverable_asset_id: Int!, $id: Int) {
        detachMedia(project_id: $project_id, project_deliverable_id: $project_deliverable_id, deliverable_asset_id: $deliverable_asset_id, id: $id)
    }
`;

export const REORDER_PROJECT_DELIVERABLE_ASSETS_MUTATION = `
    mutation ReorderAssets($project_id: Int!, $project_deliverable_id: Int!, $deliverable_asset_ids: [Int]!) {
        reorderAssets(project_id: $project_id, project_deliverable_id: $project_deliverable_id, deliverable_asset_ids: $deliverable_asset_ids) {
            id
            versions {
                id
                media {
                    id
                    name
                    type
                    status
                    description
                }
            }
        }
    }
`;

export const ATTACH_PROJECT_DELIVERABLE_DESTINATION_MUTATION = `
    mutation AttachDestination($project_id: Int!, $project_deliverable_id: Int!, $account_social_channel_id: Int!, $status: ProjectDeliverableDestinationStatusEnum!, $url: String) {
        attachDestination(project_id: $project_id, project_deliverable_id: $project_deliverable_id, account_social_channel_id: $account_social_channel_id, status: $status, url: $url) {
            url
            status
            id
            project_deliverable {
                id
                name
                type
            }
            account_social_channel {
                id
                handle
                type
                url
                avatar
            }
        }
    }
`;

export const UPDATE_PROJECT_DELIVERABLE_DESTINATION_MUTATION = `
    mutation UpdateDestination($project_id: Int!, $id: Int!, $account_social_channel_id: Int, $status: ProjectDeliverableDestinationStatusEnum, $url: String) {
        updateDestination(project_id: $project_id, id: $id, account_social_channel_id: $account_social_channel_id, status: $status, url: $url) {
            id
            url
            status
            project_deliverable {
                id
                name
                type
            }
            account_social_channel {
                id
                handle
                type
                url
                avatar
            }
        }
    }
`;

export const DETACH_PROJECT_DELIVERABLE_DESTINATION_MUTATION = `
    mutation DetachDestination($project_id: Int!, $id: Int!) {
        detachDestination(project_id: $project_id, id: $id) 
    }
`;


export const ATTACH_DELIVERABLE_PRODUCT_MUTATION = `
    mutation AttachProduct($product_id: Int!, $project_id: Int!, $deliverable_id: Int!) {
        attachProduct(account_product_id: $product_id, project_id: $project_id, project_deliverable_id: $deliverable_id) {
            id
            name
            image_url
        }
    }
`;

export const DETACH_DELIVERABLE_PRODUCT_MUTATION = `
    mutation DetachProduct($product_id: Int!, $project_id: Int!, $deliverable_id: Int!) {
        detachProduct(account_product_id: $product_id, project_id: $project_id, project_deliverable_id: $deliverable_id)
    }
`;